var _path, _rect, _rect2, _rect3, _rect4, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _line2, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunnelLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 152,
    viewBox: "0 0 185 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5899 51.4376C95.3916 51.4375 95.1945 51.405 95.0064 51.3416L88.8115 49.2604C88.4431 49.1354 88.123 48.8964 87.8969 48.5773C87.6707 48.2581 87.5499 47.8752 87.5516 47.4828V38.1802C87.5499 38.1765 87.5476 38.173 87.5447 38.1701L74.5095 22.8409C74.2205 22.501 74.0341 22.0844 73.9726 21.6407C73.9111 21.197 73.9769 20.7448 74.1624 20.3378C74.3479 19.9307 74.6451 19.586 75.0189 19.3444C75.3926 19.1029 75.8272 18.9747 76.271 18.9751H108.729C109.173 18.9747 109.608 19.1029 109.982 19.3444C110.355 19.586 110.653 19.9307 110.838 20.3378C111.023 20.7448 111.089 21.197 111.028 21.6407C110.966 22.0844 110.78 22.501 110.491 22.8409L97.4519 38.1717C97.4492 38.1748 97.4469 38.1782 97.4449 38.1818V49.5647C97.4456 49.8109 97.3981 50.0548 97.3052 50.2823C97.2122 50.5099 97.0756 50.7166 96.9032 50.8907C96.7308 51.0647 96.526 51.2026 96.3006 51.2965C96.0753 51.3904 95.8337 51.4383 95.5899 51.4376Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 183,
    height: 150,
    rx: 11,
    fill: "white",
    stroke: "#A0A0A0",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 167,
    height: 66,
    rx: 6,
    fill: "#B6B6B6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 58,
    width: 114,
    height: 28,
    rx: 6,
    fill: "#D5D5D5",
    stroke: "white",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 91,
    width: 114,
    height: 15,
    rx: 4,
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5899 51.4376C95.3916 51.4375 95.1945 51.405 95.0064 51.3416L88.8115 49.2604C88.4431 49.1354 88.123 48.8964 87.8969 48.5773C87.6707 48.2581 87.5499 47.8752 87.5516 47.4828V38.1802C87.5499 38.1765 87.5476 38.173 87.5447 38.1701L74.5095 22.8409C74.2205 22.501 74.0341 22.0844 73.9726 21.6407C73.9111 21.197 73.9769 20.7448 74.1624 20.3378C74.3479 19.9307 74.6451 19.586 75.0189 19.3444C75.3926 19.1029 75.8272 18.9747 76.271 18.9751H108.729C109.173 18.9747 109.608 19.1029 109.982 19.3444C110.355 19.586 110.653 19.9307 110.838 20.3378C111.023 20.7448 111.089 21.197 111.028 21.6407C110.966 22.0844 110.78 22.501 110.491 22.8409L97.4519 38.1717C97.4492 38.1748 97.4469 38.1782 97.4449 38.1818V49.5647C97.4456 49.8109 97.3981 50.0548 97.3052 50.2823C97.2122 50.5099 97.0756 50.7166 96.9032 50.8907C96.7308 51.0647 96.526 51.2026 96.3006 51.2965C96.0753 51.3904 95.8337 51.4383 95.5899 51.4376Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 64,
    r: 2,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 64,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 64,
    r: 2,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 63.75,
    x2: 89,
    y2: 63.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 63.75,
    x2: 109,
    y2: 63.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 109,
    width: 49,
    height: 11,
    rx: 4,
    fill: "#D5D5D5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 123,
    width: 49,
    height: 11,
    rx: 4,
    fill: "#D5D5D5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 109,
    width: 49,
    height: 11,
    rx: 4,
    fill: "#D5D5D5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 123,
    width: 49,
    height: 11,
    rx: 4,
    fill: "#D5D5D5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelLight);
export default __webpack_public_path__ + "static/media/funnel-light.047a72dfc2c374288b175ff2c21771f6.svg";
export { ForwardRef as ReactComponent };